module.exports = __webpack_public_path__ + "media/images/icons/person-c91fca35402e9d35241e229c48bdb3cb.svg";